import React from "react";
import { useParams } from "react-router-dom";
import { HeadWiseReport } from "../../components/HeadWiseReport";
import { NoAccessPanel, ReadOnlyNotice } from "../../components/FeatureGate";
import { PageHeader } from "../../components/common";
import { useRoleModules } from "../../lib/roleModules";

/** Phase 230 — Admin › Reports › Head-wise Collection: the whole municipality, every tax head (User Charges vs Property Tax ...)
 *  with demand / collected / outstanding and the year, zone & ward, payment-mode and collector breakdowns.
 *  Role Access feature `reports.head_wise`: "View only" shows the report on screen, "Full access" also allows Excel / PDF. */
export default function HeadWiseCollection() {
  const { code } = useParams();
  const access = useRoleModules(code);
  if (access.loaded && !access.featureAllowed("reports", "head_wise")) {
    return (
      <div>
        <PageHeader title="Head-wise Collection" subtitle="Demand, collected and outstanding per tax head" />
        <NoAccessPanel what="the Head-wise Collection report" testId="head-wise-no-access" />
      </div>
    );
  }
  const canDownload = !access.loaded || access.featureLevel("reports", "head_wise") === "write";
  return (
    <div className="space-y-4">
      {access.loaded && !canDownload && <ReadOnlyNotice what="this report" testId="head-wise-readonly-notice" />}
      <HeadWiseReport code={code} canDownload={canDownload} areaLevels={["zone", "supervisor", "ward", "mohalla"]}
        subtitle="Demand, collected and outstanding per tax head — User Charges, Property Tax, Water Tax ... — for the whole municipality" />
    </div>
  );
}
